import React from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Navbar from "./navigationbar/Navbar";
import HomePage from "./HomePage";
import ForgotPasswordPage from "./auth/forgotpassword/ForgotPasswordPage";
import AccountPage from "./account/AccountPage";
import SignInPage from "./auth/signin/SignInPage";
import NotFound from "./error/NotFound";
import {SignUpSuccess} from "./auth/signup/SignUpSuccess";
import {
    ACCOUNT, UNIT, NEW_USER_SUCCESS, FORGOT_PASSWORD, SIGN_IN, SIGN_OUT,
    WILDCARD, PASSWORD_RESET_SUCCESS, MESSAGES, FORBIDDEN, HOME, RECORDING_QUERY, NOT_FOUND
} from "../constants/routes";
import withAuthentication from "./WithAuthentication";
import {PasswordResetSuccess} from "./auth/forgotpassword/PasswordResetSuccess";
import {Footer} from "./footer/Footer";
import NotificationsPage from "./notifications/NotificationsPage";
import {Forbidden} from "./error/Forbidden";
import UnitPage from "./unit/UnitPage";
import Recording from "./recording/Recording";
import {NotificationContainer} from "react-notifications";
import Popup from 'react-popup';
import './styles.css';

/**
 * The main react application which comprises of
 * a header {@see Navbar} and the main body of {@see Route}s.
 * {@see Route}s in the main body can be stuff like:
 *  - {@see HomePage} page,
 *  - {@see SignInPage},
 *  - Any other page/component/script we require.
 */
const App = () => {
    return (
        <Router>
            <div>
                <Navbar />
                <Switch>
                    <Route path={HOME} exact component={HomePage} />
                    <Route path={UNIT} exact component={UnitPage} />
                    <Route path={RECORDING_QUERY} exact component={Recording} />
                    <Route path={MESSAGES} exact component={NotificationsPage} />
                    <Route path={SIGN_IN} exact component={SignInPage} />
                    <Route path={SIGN_OUT} exact component={SignInPage} />
                    <Route path={FORGOT_PASSWORD} exact component={ForgotPasswordPage} />
                    <Route path={ACCOUNT} exact component={AccountPage} />
                    <Route path={NEW_USER_SUCCESS} exact component={SignUpSuccess} />
                    <Route path={PASSWORD_RESET_SUCCESS} exact component={PasswordResetSuccess} />
                    <Route path={FORBIDDEN} component={Forbidden} />
                    <Route path={NOT_FOUND} component={NotFound} />
                    <Route path={WILDCARD} component={NotFound} />
                </Switch>
                <Footer />
                <NotificationContainer/>
                <Popup
                    closeBtn={false}
                    defaultOk="Ok"
                    defaultCancel="Cancel"
                    escToClose={true}
                />
            </div>
        </Router>
    );
};

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App.js